import type { ReactElement } from 'react';
import { pdfjs } from 'react-pdf';

// If PDF packages are updated, this URL will need to be updated
pdfjs.GlobalWorkerOptions.workerSrc =
  'https://firebasestorage.googleapis.com/v0/b/bamboo-artwork-372213.appspot.com/o/public%2Fnew.pdf.worker.min.mjs?alt=media';

export const mergePDFs = async (pdfBuffers: ArrayBuffer[]) => {
  const { PDFDocument } = await import('pdf-lib');
  const { Buffer } = await import('buffer');

  const mergedPdf = await PDFDocument.create();
  // eslint-disable-next-line no-restricted-syntax
  for (const pdfBytes of pdfBuffers) {
    const pdf = await PDFDocument.load(pdfBytes);
    const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
    copiedPages.forEach(page => {
      mergedPdf.addPage(page);
    });
  }

  const buf = await mergedPdf.save();
  return Buffer.from(buf);
};

export async function renderPDF(element: ReactElement) {
  const { pdf } = await import('@react-pdf/renderer');
  return pdf(element);
}
